import api from '../utils/api';

export const branchService = {
  // Get all branches
  getBranches: async () => {
    try {
      return await api.get('/admin/branches');
    } catch (error) {
      console.error('Error fetching branches:', error);
      throw error;
    }
  },

  // Create a new branch
  createBranch: async (branchData) => {
    try {
      return await api.post('/admin/branches', { data: branchData });
    } catch (error) {
      console.error('Error creating branch:', error);
      throw error;
    }
  },

  // Update an existing branch
  updateBranch: async (branchId, branchData) => {
    try {
      return await api.put(`/admin/branches/${branchId}`, { data: branchData });
    } catch (error) {
      console.error('Error updating branch:', error);
      throw error;
    }
  },

  // Delete a branch
  deleteBranch: async (branchId) => {
    try {
      return await api.delete(`/admin/branches/${branchId}`);
    } catch (error) {
      console.error('Error deleting branch:', error);
      throw error;
    }
  },
};